module.exports = __webpack_public_path__ + "static/media/qasem.f0da6bd3.png";